import { render, staticRenderFns } from "./CommercialProductCreate.vue?vue&type=template&id=cdc91422&scoped=true&"
import script from "./CommercialProductCreate.vue?vue&type=script&lang=js&"
export * from "./CommercialProductCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdc91422",
  null
  
)

export default component.exports